import { feed, hotRank, countUpHighlights } from "@/mocks/homeData";

export default function Hero() {
  const featured = feed[0];
  return (
    <section id="top" className="relative overflow-hidden bg-background-100/70">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-3xl"
      />

      <div className="relative mx-auto max-w-7xl px-4 pb-10 pt-8 md:px-6 md:pb-12 md:pt-10">
        <div className="flex flex-col gap-2 text-center">
          <span className="mx-auto inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-1.5 text-xs font-semibold text-secondary-700 ring-1 ring-secondary-200">
            <i className="ri-flashlight-fill text-primary-500" />
            谁在转型 · 谁在停更 · 谁在悄悄涨粉
          </span>
          <h1 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-[44px] md:leading-[1.15]">
            网红动态的第一手观察，<span className="text-primary-600">每日刷新不迷路</span>
          </h1>
          <p className="mx-auto mt-1 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            直击网红、主播、达人与大V的最新动态，追踪日常更新、内容变化与商业动作。为想了解行业风向、借鉴内容思路或单纯关注喜欢的博主的你，提供一份有信源、有态度的吃瓜手记。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:mt-10 md:grid-cols-4 md:gap-4">
          {countUpHighlights.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-background-200/80 bg-background-50 px-4 py-3 text-center"
            >
              <p className="font-heading text-xl font-black text-primary-600 md:text-2xl">{s.value}</p>
              <p className="mt-0.5 text-[11px] text-foreground-600 md:text-xs">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-[1.6fr_1fr]">
          {/* 头条 */}
          <article className="group overflow-hidden rounded-3xl border border-background-200 bg-background-50">
            <div className="relative overflow-hidden">
              <div className="h-[300px] w-full md:h-[360px]">
                <img
                  src={featured.image}
                  alt={`头条：${featured.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-fire-fill" />
                今日头条
              </span>
              <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
                <i className="ri-time-line text-primary-600" />
                {featured.timeLabel}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-800">
                  {featured.tag}
                </span>
                <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                  {featured.authorTag}
                </span>
              </div>
              <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <a href="#latest" className="transition-colors hover:text-primary-600">
                  {featured.title}
                </a>
              </h2>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-700">
                {featured.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-600">文 / {featured.author}</span>
                <div className="flex items-center gap-4 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {featured.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-thumb-up-line" />
                    {featured.likes}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {featured.comments}
                  </span>
                </div>
              </div>
            </div>
          </article>

          {/* 今日热榜 */}
          <aside id="hot" className="rounded-3xl border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-fire-line" />
                </span>
                今日吃瓜热榜
              </h2>
              <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-800">
                <i className="ri-refresh-line" /> 实时
              </span>
            </div>
            <ol className="mt-4 space-y-2">
              {hotRank.map((r) => (
                <li key={r.id}>
                  <a
                    href="#latest"
                    className="group flex items-center gap-3 rounded-xl px-2 py-2 transition-colors hover:bg-background-100"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg font-heading text-sm font-black ${
                        r.rank === 1
                          ? "bg-primary-500 text-background-50"
                          : r.rank <= 3
                          ? "bg-accent-200 text-accent-900"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {r.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                        {r.title}
                      </p>
                      <p className="mt-0.5 text-[11px] text-foreground-500">
                        <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-800">
                          {r.tag}
                        </span>
                        <span className="ml-2 inline-flex items-center gap-0.5">
                          <i className="ri-fire-line text-primary-500" />
                          {r.heat}
                        </span>
                      </p>
                    </div>
                    <span
                      className={`shrink-0 text-[11px] font-semibold ${
                        r.up ? "text-primary-600" : "text-foreground-400"
                      }`}
                    >
                      {r.delta}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
            <p className="mt-3 border-t border-dashed border-background-200 pt-3 text-[11px] leading-relaxed text-foreground-500">
              榜单按公开热度与关注度动态计算，仅反映讨论趋势，不代表任何官方结论。
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}